import {FC} from 'react'

import cn from 'classnames/bind'
import Image from 'next/legacy/image'

import {Container} from 'components/elements/grid'
import {IInvoiceContent} from 'pages/invoice-generator'

import s from './InvoiceReasons.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceReasonsProps {
	className?: string
	content: IInvoiceContent['reasons']
}

/** InvoiceReasons block component */
const InvoiceReasons: FC<IInvoiceReasonsProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<ul className={s.list}>
					{content?.items?.map((item) => (
						<li className={s.item} key={item._key || item.title}>
							<div className={cx('item__figure')}>
								<Image
									className={s.icon}
									layout="fixed"
									src={item.icon || ''}
									width="88"
									height="88"
									alt={`${item.title} icon`}
								/>
							</div>
							<h3 className={cx('h3', 'item__title')}>{item.title}</h3>
							<p className={cx('item__description')}>{item.description}</p>
						</li>
					))}
				</ul>
			</Container>
		</div>
	)
}

InvoiceReasons.displayName = 'InvoiceReasons'

export default InvoiceReasons
